import React, { useState, useMemo } from "react";
import { Modal, Button } from "react-bootstrap";

function AlertModal({ onClose, title, message }: { onClose?: () => void, title: string, message: string }) {
  const [closed, setClosed] = useState(false);
  const show = useMemo(() => !closed, [closed]);

  const onCloseClick = () => {
    setClosed(true);
    if (onClose) onClose();
  };

  return (
    <Modal show={show} onHide={() => setClosed(true)}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="warning" onClick={onCloseClick}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AlertModal;
